import { useRecoilValue } from 'recoil';
import { viewDataGridSizeType } from 'venn-state';
import { assertExhaustive } from 'venn-utils';
import { DataGridSizeType } from '../components/grid/types';
import { useBlockId } from '../contexts/BlockIdContext';

export const useIsBlockGridCompact = () => {
  const blockId = useBlockId();
  const dataGridSizeType = useRecoilValue(viewDataGridSizeType(blockId));

  switch (dataGridSizeType) {
    case DataGridSizeType.COMPACT:
      return true;
    case DataGridSizeType.DEFAULT:
    case undefined:
      return false;
    default:
      throw assertExhaustive(dataGridSizeType);
  }
};
